import { t } from "i18next";
import { useLocation } from "react-router-dom";

export function isEqual(...args) {
  return Object.values(args).every(
    (val, i, arr) => String(val).toLowerCase() === String(arr[0]).toLowerCase()
  );
}

export function shuffleArray(array) {
  return array.sort(() => Math.random() - 0.5);
}

export function formatMessage(message) {
  if (message.includes(" ")) {
    return message;
  }
  return t(message);
}

export const clearAllLocalStorage = () => {
  const walkthroughDone = localStorage.getItem("walkthroughDone");
  localStorage.clear();
  if (walkthroughDone === "true") {
    localStorage.setItem("walkthroughDone", true);
  }
};

export const useSearch = () => {
  let { search } = useLocation();
  const queryParamsFromStorage = localStorage.getItem("queryParam")
  if ((!search || !search.includes('utm_source')) && queryParamsFromStorage) {
    if (!search) {
      search = queryParamsFromStorage
    } else {
      search += '&' + queryParamsFromStorage.slice(1)
    }
  }
  const searchParams = new URLSearchParams(search); 
  const searchParamsObj = Object.fromEntries(searchParams.entries());
  for (const key in searchParamsObj) {
    searchParamsObj[key] = searchParamsObj[key]
      .split("?")[0];
  }
  return { ...searchParamsObj };
}